import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-detail-page-header',
    templateUrl: './detail-page-header.component.html',
    styleUrls: ['./detail-page-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DetailPageHeaderComponent implements OnInit {

    @Input() showTopTitleButton: boolean = true;
    @Input() navigateUrl: string;
    @Input() image: string = './assets/images/cards/20-640x480.jpg';

    constructor(
        private _router: Router,) { }

    ngOnInit(): void {
    }

    public navigateTo(): void {
        this._router.navigate(['./' + this.navigateUrl]);
    }

    public errorHandler(event: any): void {
        event.target.src = './assets/images/cards/20-640x480.jpg';
    }
}
